module.exports = __webpack_public_path__ + "img/product-10.8b53a024.jpg";